import { call, put, takeLatest } from "redux-saga/effects";

import { apiGetDetailArticles } from "helpers/api/articles";
import {
  GET_DETAIL_ARTICLES,
  actGetDetailArticlesFailed,
  actGetDetailArticlesSuccess,
} from "store/actions/articles";
import { showToastError } from "utils";

/**
 * Handle get data request and response
 * @param {object} action
 */
function* doGetDetail(action) {
  try {
    const response = yield call(apiGetDetailArticles, action?.payload);

    if (response?.data) {
      // Call callback action if provided
      yield put(actGetDetailArticlesSuccess(response.data));

      if (action.onSuccess) {
        yield action.onSuccess();
      }
    }
  } catch (error) {
    yield put(actGetDetailArticlesFailed());
    // Call callback action if provided
    showToastError(error?.message);
    if (action.onError) {
      yield action.onError(error);
    }
  }
}

export default function* watchGetDetail() {
  yield takeLatest(GET_DETAIL_ARTICLES, doGetDetail);
}
